import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AI_ASSESSMENT_GAUGE_PALETTE_MAX_5, DetailsChartsDto } from '@pt/pt-models';
import { AiAssessmentsService } from '@pt/api-client';
import { ActionsSubject, Store } from '@ngrx/store';
import { AiAssessmentDetails, AiAssessmentEvaluation } from '@primatoo-ms-organization';
import { StatsChartBuilder } from '../../utils';
import { NgrxWidgetActions } from '..';
import { ofType } from '@ngrx/effects';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';


@UntilDestroy()
@Component({
  selector: 'pt-ai-result',
  template: `
    <div class="mb-2 mt-4">
      <pt-details-chart
        [showReloadButton]="requireReload && !autoReload"
        [title]="'LABELS.AI_ASSESSMENTS' | translate"
        [gaugeColor]='gaugeColor'
        [charts]='charts'
        (reload)="reloadResult()">
      </pt-details-chart>
    </div>
  `
})
export class AiResultComponent implements OnChanges, OnInit {
  @Input() docId: number;
  @Input() requireReload: boolean;
  @Input() autoReload = false;
  public gaugeColor = AI_ASSESSMENT_GAUGE_PALETTE_MAX_5;
  public charts: DetailsChartsDto[];
  private result: AiAssessmentEvaluation;

  constructor(private service: AiAssessmentsService,
              private actionsSubject: ActionsSubject,
              private store: Store) {
  }

  ngOnInit(): void {
    this.actionsSubject.pipe(
      ofType(
        NgrxWidgetActions.forceReloadedResult
      ),
      untilDestroyed(this)
    ).subscribe((action) => {
      this.reloadResult();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.docId) {
      this.reloadResult();
    }

    if (changes.requireReload) {
      if (this.requireReload && this.autoReload) {
        this.reloadResult();
      }
    }

  }

  public reloadResult() {
    this.service?.getDetails(this.docId).subscribe((result: AiAssessmentDetails) => {
      this.result = result.evaluation;
      this.alignWidget(this.result);
      this.store.dispatch(NgrxWidgetActions.reloadedResult());
    }, () => {
      this.result = undefined;
      this.store.dispatch(NgrxWidgetActions.reloadedResult());
    });
  }

  private alignWidget(evaluation: AiAssessmentEvaluation) {
    this.charts = StatsChartBuilder.buildAiAssessmentStats(evaluation);
  }
}
